/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsChangePaymentMode
 */
export interface MelcoModelsChangePaymentMode {
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsChangePaymentMode
     */
    payment_mode?: number;
}

export function MelcoModelsChangePaymentModeFromJSON(json: any): MelcoModelsChangePaymentMode {
    return MelcoModelsChangePaymentModeFromJSONTyped(json, false);
}

export function MelcoModelsChangePaymentModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsChangePaymentMode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payment_mode': !exists(json, 'payment_mode') ? undefined : json['payment_mode'],
    };
}

export function MelcoModelsChangePaymentModeToJSON(value?: MelcoModelsChangePaymentMode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payment_mode': value.payment_mode,
    };
}


